import Cookies from 'js-cookie';

class GoogleAnalyticsCompanion {

  getID() {
    return Cookies.get('_ga');
  }

}

export default GoogleAnalyticsCompanion;